import { render, staticRenderFns } from "./common-bulk-message-list.vue?vue&type=template&id=e90cd4f2"
import script from "./common-bulk-message-list.vue?vue&type=script&lang=js"
export * from "./common-bulk-message-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e90cd4f2')) {
      api.createRecord('e90cd4f2', component.options)
    } else {
      api.reload('e90cd4f2', component.options)
    }
    module.hot.accept("./common-bulk-message-list.vue?vue&type=template&id=e90cd4f2", function () {
      api.rerender('e90cd4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/common-bulk-message-list.vue"
export default component.exports